module.exports = __webpack_public_path__ + "img/illustation_character_1.png";